import { createFileRoute } from "@tanstack/react-router";
import { i18nLinks, i18nOgMeta, localeUrl } from "@/lib/seo";
import { m } from "@/paraglide/messages";
import { SyllableCounterIndex } from "@/tools/syllable-counter/pages/SyllableCounterIndex";

const PATH = "/syllable-counter";

export const Route = createFileRoute("/syllable-counter/")({
  ssr: true,
  head: () => ({
    meta: [
      { title: m.syl_hub_meta_title() },
      { name: "description", content: m.syl_hub_meta_description() },
      { property: "og:title", content: m.syl_hub_meta_title() },
      { property: "og:description", content: m.syl_hub_meta_description() },
      ...i18nOgMeta(PATH),
    ],
    links: [...i18nLinks(PATH)],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: m.syl_breadcrumb_home(),
              item: localeUrl(`/`),
            },
            {
              "@type": "ListItem",
              position: 2,
              name: m.syl_tool_name(),
              item: localeUrl(`${PATH}`),
            },
          ],
        }),
      },
    ],
  }),
  component: SyllableCounterIndex,
});
